import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=389895a6&scoped=true&lang=pug&"
import script from "./Textarea.vue?vue&type=script&lang=js&"
export * from "./Textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389895a6",
  null
  
)

export default component.exports